import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      component: () => import('@/views/Index'),
      children: [
        {
          name: 'dashboard',
          path: '',
          component: () => import('@/views/Dashboard'),
        },
        {
          name: 'users',
          path: 'users/operations',
          component: () => import('@/views/users/Operations'),
        },
        {
          name: 'user_category',
          path: 'users/category',
          component: () => import('@/views/users/Category'),
        },
        {
          name: 'user_settings',
          path: 'users/settings',
          component: () => import('@/views/users/Settings'),
        },
        {
          name: 'products',
          path: 'products/operations',
          component: () => import('@/views/products/Operations'),
        },
        {
          name: 'product_category',
          path: 'products/category',
          component: () => import('@/views/products/Category'),
        },
        {
          name: 'product_settings',
          path: 'products/settings',
          component: () => import('@/views/products/Settings'),
        },
        {
          name: 'product_attributes',
          path: 'products/attributes',
          component: () => import('@/views/products/Attributes'),
        },
        {
          name: 'pages',
          path: 'pages/operations',
          component: () => import('@/views/pages/Operations'),
        },
        {
          name: 'pages_settings',
          path: 'pages/settings',
          component: () => import('@/views/pages/Settings'),
        },
        {
          name: 'sliders',
          path: 'sliders/operations',
          component: () => import('@/views/sliders/Operations'),
        },
        {
          name: 'blog',
          path: 'blog/operations',
          component: () => import('@/views/blog/Operations'),
        },
        {
          name: 'blog_category',
          path: 'blog/category',
          component: () => import('@/views/blog/Category'),
        },
        {
          name: 'blog_settings',
          path: 'blog/settings',
          component: () => import('@/views/blog/Settings'),
        },
        {
          name: 'forms',
          path: 'forms/operations',
          component: () => import('@/views/forms/Operations'),
        },
        {
          name: 'forms_settings',
          path: 'forms/settings',
          component: () => import('@/views/forms/Settings'),
        },
        {
          name: 'forms_results',
          path: 'forms/results',
          component: () => import('@/views/forms/Results'),
        },
        {
          name: 'questions',
          path: 'questions/operations',
          component: () => import('@/views/questions/Operations'),
        },
        {
          name: 'questions_category',
          path: 'questions/category',
          component: () => import('@/views/questions/Category'),
        },
        {
          name: 'questions_settings',
          path: 'questions/settings',
          component: () => import('@/views/questions/Settings'),
        },
      ],
    },
    {
      name: 'login',
      path: '/login',
      component: () => import('@/views/Login'),
    },
  ],
})
